
<div class="contact-page-skeleton">
  <wp-skeleton class="-skeleton-title" [loading]="true"></wp-skeleton>
  <wp-skeleton class="-skeleton-description" [loading]="true"></wp-skeleton>
  <div class="-skeleton-cards">
    <wp-skeleton class="-skeleton-card" [loading]="true"></wp-skeleton>
    <wp-skeleton class="-skeleton-card" [loading]="true"></wp-skeleton>
  </div>
</div>
